import { Schema } from "@effect/schema";
import { Amount, Percent, Usd } from "@silo/types";

export type RevenueData = typeof RevenueData.Type;
export type RevenueDataEncoded = typeof RevenueData.Encoded;

export const RevenueData = Schema.Struct({
  revenueApr: Percent,
  emissionPerSecond: Amount,
  rewardTokenPriceUsd: Usd,
  totalTokens: Amount,
  tokenPriceUsd: Usd,
  revenueBalance: Amount,
  revenueBalanceUsd: Usd,
}).annotations({ identifier: "RevenueData" });
